var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import PropTypes from 'prop-types';
import { withFormik } from 'formik';
import { Button, Card, CardBody, CardHeader, CustomInput, FormGroup, Input, Label, Spinner, } from 'reactstrap';
import LogService, { createDerivedStateFromErrorLogger } from '../../utils/log';
import { addressFields, personalFields, DeliveryTypes, } from '../../order-fields';
import Shapes from 'Shapes';
import { currency } from '../../config';
import OtoError from '../common/OtoError';
import OrderFormAddress from './OrderFormAddress';
import PromoCode from './PromoCode';
import { AnalyticsService } from '../../utils/tracking';
import DeliveryService, { geocodeByAddress, getRestaurantIsDelivering, hasMaxDistance, } from '../../utils/location';
import { getDynamicDeliveryText, getMinimumDeliveryTime, getMinimumCartAmount, hasDynamicDeliveryPrice, } from '../../utils/restaurant';
import { getAllowedDeliveryOptions, getAllowedPaymentOptions, } from '../../utils/order';
import CustomerDetails from './CustomerDetails';
import Tag from 'Icons/Tag';
import Utensils from 'Icons/Utensils';
import AlertIcon from 'Icons/Alert';
import { getOrderFormInitialValues, handleOrderFormSubmit, validateOrderForm, } from './OrderFormHelpers';
import OrderFormDeliveryErrors from './OrderFormDeliveryErrors';
import { getIsMinDeliveryAchieved } from 'Utils/basket-status';
import { omit } from 'App/app/general';
import RobotDeliveryPromoBanner from './RobotDeliveryPromoBanner';
import OrderFormDeliveryTime from './OrderFormDeliveryTime';
import CartSummary from 'Comps/Cart/CartSummary';
import OrderFormConsent from './OrderFormConsent';
var COMPONENT_NAME = 'PureOrderForm';
var OrderForm = /** @class */ (function (_super) {
    __extends(OrderForm, _super);
    function OrderForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            addressInRangeMessage: '',
            canOrderRobotDelivery: false,
            distanceLoading: false,
            hasError: null,
        };
        _this.updatePaymentIfNotAvailable = function (nextProps) {
            var _a = nextProps.values, nextDelivery = _a.delivery, nextPayment = _a.payment;
            var nextAvailablePayments = getAllowedPaymentOptions(nextProps.restaurantDetails, nextDelivery);
            if (!nextAvailablePayments.filter(function (opt) { return opt.name === nextPayment; }).length) {
                nextProps.setFieldValue('payment', nextAvailablePayments[0].name);
            }
        };
        _this.updateDeliveryModeIfTakeoutStateChanged = function (currentDelivery, nextDelivery) {
            var becameTakeout = currentDelivery !== DeliveryTypes.takeout &&
                nextDelivery === DeliveryTypes.takeout;
            var becameNotTakeout = currentDelivery === DeliveryTypes.takeout &&
                nextDelivery !== DeliveryTypes.takeout;
            if (becameTakeout) {
                _this.props.updateDeliveryMode(DeliveryTypes.takeout);
                _this.clearErrors(['address', 'house']);
            }
            else if (becameNotTakeout) {
                _this.props.updateDeliveryMode(DeliveryTypes.usual);
                _this.ensureAddressIsValid();
            }
        };
        _this.updateDeliveryTypeIfRobotStateChanged = function (currentDelivery, nextDelivery) {
            if (currentDelivery === DeliveryTypes.robot ||
                nextDelivery === DeliveryTypes.robot) {
                _this.props.updateDeliveryType(nextDelivery);
            }
        };
        _this.ensureAddressIsValid = function () {
            var address = _this.getAddress();
            _this.setState({ distanceLoading: true, canOrderRobotDelivery: false });
            return new Promise(function (resolve) {
                return geocodeByAddress(address)
                    .then(function (googleMapsPlace) {
                    var newDeliveryPrefs = DeliveryService.mapGooglePlaceToDeliveryPrefs(googleMapsPlace, address, _this.props.deliveryMode);
                    DeliveryService.saveDeliveryPreferences(newDeliveryPrefs, 'order form');
                    _this.props.updateDeliveryPrefs(newDeliveryPrefs);
                    var coordinates = newDeliveryPrefs.coordinates;
                    // TODO remove duplicated checkIfGeoPositionIsValid usage in OrderForm and RestaurantMenuPage
                    return _this.checkIfGeoPositionIsValid(coordinates, resolve);
                })
                    .catch(function () {
                    _this.setState({
                        distanceLoading: false,
                        canOrderRobotDelivery: false,
                    });
                    _this.setWrongAddressError(address);
                    resolve(false);
                });
            });
        };
        /*
        TODO - remove duplicated checkIfGeoPositionIsValid function
        and leave in only at RestaurantMenu page.
        to disable submit button - check if delivering passed as props
        */
        _this.checkIfGeoPositionIsValid = function (position, resolve) {
            var _a = _this.props, restaurant = _a.restaurant, restaurantDetails = _a.restaurantDetails, setFieldValue = _a.setFieldValue, setFieldTouched = _a.setFieldTouched, setErrors = _a.setErrors;
            var address = _this.getAddress();
            getRestaurantIsDelivering(restaurant, position)
                .then(function (data) {
                var canOrderRobotDelivery = data.canOrderRobotDelivery, delivering = data.delivering, price = data.price;
                if (delivering) {
                    // todo potentially too many calls - to investigate
                    _this.props.checkBasketStatus();
                    _this.clearErrors(['address']);
                    if (hasDynamicDeliveryPrice(restaurantDetails)) {
                        var deliveryPrice = price;
                        _this.setState({
                            addressInRangeMessage: "Koszt dostawy do adresu ".concat(address, ": ").concat(deliveryPrice).concat(currency),
                            canOrderRobotDelivery: canOrderRobotDelivery,
                            distanceLoading: false,
                        });
                        setFieldValue('customDeliveryPrice', deliveryPrice);
                    }
                    else {
                        _this.setState({
                            addressInRangeMessage: "Dostawa pod adres ".concat(address, " jest mo\u017Cliwa."),
                            canOrderRobotDelivery: canOrderRobotDelivery,
                            distanceLoading: false,
                        });
                    }
                    resolve && resolve(true);
                }
                else {
                    setFieldTouched('address', true, false);
                    setErrors(__assign(__assign({}, _this.props.errors), { address: "Brak mo\u017Cliwo\u015Bci dostawy - adres ".concat(address, " jest poza zasi\u0119giem.") }));
                    _this.setState({
                        addressInRangeMessage: '',
                        canOrderRobotDelivery: canOrderRobotDelivery,
                        distanceLoading: false,
                    });
                    AnalyticsService.trackDeliveryOutOfRange(restaurant);
                    resolve && resolve(false);
                }
            })
                .catch(function (e) {
                LogService.fetchError({
                    actionName: 'getRestaurantIsDelivering',
                    url: "/restaurants/".concat(restaurant.id, "/distance?lng=").concat(position.lng, "&lat=").concat(position.lat),
                    e: e,
                });
                _this.setState({ canOrderRobotDelivery: false, distanceLoading: false });
                setErrors({
                    hasError: "Wyst\u0105pi\u0142 b\u0142\u0105d podczas wyznaczenia odleg\u0142o\u015Bci dla adresu ".concat(address),
                });
                resolve && resolve(false);
            });
        };
        _this.getAddress = function () {
            var _a = _this.props.values, street = _a.street, house = _a.house, city = _a.city;
            return "".concat(city, ", ").concat(street, " ").concat(house || '');
        };
        _this.clearErrors = function (errorKeys) {
            var _a = _this.props, errors = _a.errors, setErrors = _a.setErrors;
            setErrors(omit(errors, errorKeys));
        };
        _this.setWrongAddressError = function (address) {
            _this.props.setErrors(__assign(__assign({}, _this.props.errors), { street: "Adres ".concat(address, " nie zosta\u0142 znaleziony, brak mo\u017Cliwo\u015Bci dostawy.") }));
        };
        _this.checkDistanceAndSubmit = function (e) {
            e.persist();
            e.preventDefault();
            e.stopPropagation();
            var _a = _this.props, restaurantDetails = _a.restaurantDetails, values = _a.values, handleSubmit = _a.handleSubmit, setSubmitting = _a.setSubmitting;
            var delivery = values.delivery;
            if ((hasMaxDistance(restaurantDetails) ||
                getDynamicDeliveryText(restaurantDetails, false)) &&
                delivery !== DeliveryTypes.takeout) {
                console.warn('checkDistanceAndSubmit sets setSubmitting to true');
                setSubmitting(true);
                _this.ensureAddressIsValid()
                    .then(function (canProceed) {
                    if (canProceed) {
                        handleSubmit(e);
                    }
                    else {
                        console.warn('checkDistanceAndSubmit sets setSubmitting to false');
                        setSubmitting(false);
                    }
                })
                    .catch(function (e) { return setSubmitting(false); });
                return false;
            }
            else {
                handleSubmit(e);
            }
        };
        _this.verifyCustomerWithFormData = function (successCallback, errorCallback) {
            return _this.props.verifyCustomer(_this.props.values, successCallback, errorCallback);
        };
        _this.noteIconStyle = { height: 20, minWidth: 20 };
        _this.renderFieldNote = function (fieldWithNote) {
            return !!fieldWithNote &&
                fieldWithNote.note && (React.createElement("div", { className: "vertical-center mt-1" },
                React.createElement(AlertIcon, { className: "text-info", style: _this.noteIconStyle }),
                ' ',
                React.createElement("span", { className: "text-muted ml-1" }, fieldWithNote.note)));
        };
        return _this;
    }
    OrderForm.prototype.componentWillReceiveProps = function (nextProps) {
        var currentDelivery = this.props.values.delivery;
        var nextDelivery = nextProps.values.delivery;
        if (currentDelivery !== nextDelivery) {
            this.updatePaymentIfNotAvailable(nextProps);
            this.updateDeliveryModeIfTakeoutStateChanged(currentDelivery, nextDelivery);
            this.updateDeliveryTypeIfRobotStateChanged(currentDelivery, nextDelivery);
        }
    };
    OrderForm.prototype.render = function () {
        var _a = this.props, basketStatus = _a.basketStatus, errors = _a.errors, handleBlur = _a.handleBlur, handleChange = _a.handleChange, restaurantDetails = _a.restaurantDetails, setFieldValue = _a.setFieldValue, touched = _a.touched, restaurant = _a.restaurant, values = _a.values;
        var hasError = this.state.hasError;
        if (hasError) {
            return React.createElement(OtoError, null);
        }
        var isTakeout = values.delivery === DeliveryTypes.takeout;
        return (React.createElement("div", null,
            React.createElement("form", { onSubmit: this.checkDistanceAndSubmit },
                React.createElement(Card, null,
                    React.createElement(CardHeader, null, "Dane kontaktowe"),
                    React.createElement(CardBody, { className: "row" },
                        React.createElement(CustomerDetails, { errors: errors, touched: touched, values: values, handleBlur: handleBlur, handleChange: handleChange }))),
                React.createElement(Card, { className: "mt-3" },
                    React.createElement(CardHeader, null, "Dane p\u0142atno\u015Bci i dostawy"),
                    React.createElement(CardBody, { className: "row pb-0" },
                        this.renderDeliveryOptions(),
                        React.createElement(OrderFormDeliveryTime, { minDeliveryTime: isTakeout ? 30 : getMinimumDeliveryTime(restaurantDetails), value: values.deliveryTime, onDeliveryTimeChange: function (time) {
                                return setFieldValue('deliveryTime', time);
                            }, onDeliveryAtChange: function (deliveryAt) {
                                return setFieldValue('deliveryAt', deliveryAt);
                            }, isTakeout: isTakeout }),
                        React.createElement("hr", { className: "col-11" }),
                        this.renderPaymentOptions(),
                        React.createElement("hr", null),
                        React.createElement(PromoCode, { handler: this.props.applyPromoCode, promoCode: this.props.promoCode, verifyCustomer: this.verifyCustomerWithFormData }))),
                restaurantDetails.askForCutlery && (React.createElement(React.Fragment, null,
                    React.createElement(Utensils, null),
                    React.createElement(Label, { className: "mt-2 ml-2" }, "Czy potrzebujesz sztu\u0107ce?"),
                    React.createElement(Input, { type: "select", className: "mw-300", name: "cutleryPreferences", onChange: handleChange, value: values.cutleryPreferences },
                        React.createElement("option", { value: "" }, "brak preferencji"),
                        React.createElement("option", { value: "yes" }, "Tak"),
                        React.createElement("option", { value: "no" }, "Nie")))),
                React.createElement(Label, { className: "mt-3" }, "Uwagi do zam\u00F3wienia"),
                React.createElement(Input, { type: "textarea", name: "notes", placeholder: "Np. kod do bramki, pi\u0119tro lub inne informacje", onChange: handleChange, value: values.notes }),
                React.createElement("div", { className: "text-primary mt-3" },
                    React.createElement(Tag, { className: "mr-1" }),
                    " Chcesz otrzymywa\u0107 informacje na temat zni\u017Cek i promocji?"),
                React.createElement(CustomInput, { type: "checkbox", className: "mt-3", name: "allowSms", id: "allowSms", label: "Wyra\u017Cam zgod\u0119 na wysy\u0142anie wiadomo\u015Bci SMS w celu marketingowym", onChange: handleChange, checked: values.allowSms }),
                React.createElement(CustomInput, { type: "checkbox", name: "allowEmail", id: "allowEmail", className: "mt-1", label: "Wyra\u017Cam zgod\u0119 na wysy\u0142anie wiadomo\u015Bci email  w celu marketingowym", onChange: handleChange, checked: values.allowEmail }),
                React.createElement(CartSummary, { basketStatus: basketStatus, isEmpty: false, isTakeoutMode: isTakeout, restaurant: restaurant }),
                this.renderFormFooter())));
    };
    OrderForm.prototype.renderDeliveryOptions = function () {
        var _a = this.props, basketStatus = _a.basketStatus, deliveryMode = _a.deliveryMode, restaurantDetails = _a.restaurantDetails, errors = _a.errors, handleChange = _a.handleChange, restaurant = _a.restaurant, setValues = _a.setValues, setErrors = _a.setErrors, touched = _a.touched, values = _a.values;
        var _b = this.state, addressInRangeMessage = _b.addressInRangeMessage, canOrderRobotDelivery = _b.canOrderRobotDelivery, distanceLoading = _b.distanceLoading;
        var availableDeliveryOptions = getAllowedDeliveryOptions(restaurantDetails, canOrderRobotDelivery);
        var isCartEnoughForDelivery = getIsMinDeliveryAchieved(basketStatus);
        var selectedOptWithNote = availableDeliveryOptions.find(function (opt) { return opt.name === values.delivery; });
        var isTakeout = values.delivery === DeliveryTypes.takeout;
        return (React.createElement(React.Fragment, null,
            React.createElement(FormGroup, { className: "col col-12" },
                React.createElement(Label, null, "Spos\u00F3b dostawy"),
                React.createElement(Input, { className: "mw-300", type: "select", name: "delivery", onChange: handleChange, value: values.delivery }, availableDeliveryOptions.map(function (opt) { return (React.createElement("option", { key: opt.name, value: opt.name },
                    opt.label,
                    opt.name === DeliveryTypes.robot && restaurant.robot_discount
                        ? " (".concat(restaurant.robot_discount.label, ")")
                        : '')); })),
                this.renderFieldNote(selectedOptWithNote),
                React.createElement(OrderFormDeliveryErrors, { cartTotal: basketStatus.price.discounted, errorClassName: "text-danger small mt-1 mb-2", deliveryMode: values.delivery, isCartEnoughForDelivery: getIsMinDeliveryAchieved(basketStatus), minCartAmount: getMinimumCartAmount(restaurant, basketStatus), restaurantDetails: restaurantDetails })),
            React.createElement(RobotDeliveryPromoBanner, { canOrderRobotDelivery: canOrderRobotDelivery, isTakeout: isTakeout }),
            React.createElement("hr", { className: "col-11" }),
            React.createElement(OrderFormAddress, { addressInRangeMessage: addressInRangeMessage, distanceLoading: distanceLoading, deliveryMode: deliveryMode, errors: errors, isTakeout: isTakeout, touched: touched, values: values, setValues: setValues, handleChange: handleChange, restaurantDetails: restaurantDetails, ensureAddressIsValid: this.ensureAddressIsValid, setErrors: setErrors })));
    };
    OrderForm.prototype.renderPaymentOptions = function () {
        var _a = this.props, handleChange = _a.handleChange, restaurantDetails = _a.restaurantDetails, values = _a.values;
        var availablePaymentOptions = getAllowedPaymentOptions(restaurantDetails, values.delivery);
        var selectedOptWithNote = availablePaymentOptions.find(function (opt) { return opt.name === values.payment; });
        return (React.createElement(FormGroup, { className: "col col-12" },
            React.createElement(Label, null, "Spos\u00F3b p\u0142atno\u015Bci"),
            React.createElement(Input, { className: "mw-300", type: "select", name: "payment", onChange: handleChange, value: values.payment }, availablePaymentOptions.map(function (opt) { return (React.createElement("option", { key: opt.name, value: opt.name, disabled: opt.disabled || false }, opt.label)); })),
            this.renderFieldNote(selectedOptWithNote)));
    };
    OrderForm.prototype.renderFormFooter = function () {
        var _a = this.props, basketStatus = _a.basketStatus, basketLoading = _a.basketLoading, errors = _a.errors, isSubmitting = _a.isSubmitting, restaurant = _a.restaurant, restaurantDetails = _a.restaurantDetails, values = _a.values;
        var distanceLoading = this.state.distanceLoading;
        if (isSubmitting || distanceLoading || basketLoading) {
            return (React.createElement("div", { className: "my-2 text-center" },
                React.createElement(Spinner, { color: "primary", className: "m-2" })));
        }
        var totalSum = basketStatus.price.withDelivery;
        var btnText = "Zamawiam i p\u0142ac\u0119 ".concat(totalSum, " ").concat(currency);
        if (Object.values(errors).filter(function (error) { return !!error; }).length) {
            var allFields_1 = __spreadArray(__spreadArray([], __read(personalFields), false), __read(addressFields), false);
            var incorrectFields = Object.keys(errors).map(function (errorName) {
                var foundField = allFields_1.find(function (field) { return field.name === errorName; });
                return foundField && foundField.label ? foundField.label : errorName;
            });
            if (incorrectFields.length === 1 && incorrectFields[0] === 'hasError') {
                if (typeof errors.hasError === 'string') {
                    return (React.createElement(OtoError, null,
                        React.createElement("p", null, errors.hasError)));
                }
                return React.createElement(OtoError, { className: "mt-3" });
            }
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "mt-3 mb-2 text-danger small" },
                    "Nast\u0119puj\u0105ce pola s\u0105 wype\u0142nione niepoprawnie:",
                    ' ',
                    incorrectFields.filter(function (f) { return f != 'hasError'; }).join(', ')),
                React.createElement(Button, { type: "submit", color: "primary", className: "cart-order-btn", disabled: true }, btnText),
                React.createElement(OrderFormConsent, null)));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(OrderFormDeliveryErrors, { cartTotal: basketStatus.price.discounted, deliveryMode: values.delivery, isCartEnoughForDelivery: getIsMinDeliveryAchieved(basketStatus), minCartAmount: getMinimumCartAmount(restaurant, basketStatus), restaurantDetails: restaurantDetails }, function (isDisabled) { return (React.createElement(Button, { color: "primary", className: "mt-3 cart-order-btn", disabled: isDisabled, type: "submit" }, btnText)); }),
            React.createElement(OrderFormConsent, null)));
    };
    OrderForm.displayName = COMPONENT_NAME;
    OrderForm.propTypes = {
        applyPromoCode: PropTypes.func.isRequired,
        basketStatus: Shapes.basketStatusShape.isRequired,
        basketLoading: PropTypes.bool.isRequired,
        cart: PropTypes.array.isRequired,
        checkBasketStatus: PropTypes.func.isRequired,
        deliveryMode: PropTypes.oneOf([DeliveryTypes.usual, DeliveryTypes.takeout])
            .isRequired,
        onOrderCreate: PropTypes.func.isRequired,
        restaurantDetails: Shapes.ordersConfigShape,
        restaurant: Shapes.deliveryRestaurantShape,
        promoCode: PropTypes.string,
        updateDeliveryMode: PropTypes.func.isRequired,
        updateDeliveryType: PropTypes.func.isRequired,
        updateDeliveryPrefs: PropTypes.func.isRequired,
        verifyCustomer: PropTypes.func.isRequired,
    };
    OrderForm.getDerivedStateFromError = createDerivedStateFromErrorLogger(COMPONENT_NAME);
    return OrderForm;
}(React.PureComponent));
export default withFormik({
    mapPropsToValues: getOrderFormInitialValues,
    validate: validateOrderForm,
    validateOnChange: false,
    handleSubmit: handleOrderFormSubmit,
    displayName: 'FormikOrderForm',
    // @ts-expect-error @TODO fix this, quick TS fix to allow build
})(OrderForm);
